(function () {
  'use strict';

  function getGloboCards(root) {
    var cards = [];

    if (root instanceof Element && root.matches('[data-globo-product-card]')) {
      cards.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll('[data-globo-product-card]').forEach(function (card) {
        cards.push(card);
      });
    }

    return cards;
  }

  function initGloboProductCards(root) {
    var cards = getGloboCards(root || document);
    if (!cards.length) return;

    if (window.theme && theme.settings.quickView && typeof window.Quick === 'function') {
      window.Quick();
    }

    if (!window.theme || !theme.settings.cart || typeof window.Cart !== 'function') return;

    cards.forEach(function (card) {
      var container = card.closest('[data-section-id]');
      if (!container) return;

      var sectionId = container.getAttribute('data-section-id');
      if (!sectionId) return;

      card.querySelectorAll('[data-globo-product-form]').forEach(function (form) {
        form.classList.add('go-to-cart-' + sectionId);
      });
      window.Cart(card, sectionId);
    });
  }

  window.addEventListener('globoFilterRenderCompleted', function () {
    initGloboProductCards(document);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initGloboProductCards(document);
  });
})();
